<template>
	<widget title="Project & Service Numbering">

		<field label=" Allow Project #'s to be edited manually"
			col-class="col-auto"
			v-model="$store.company.CompanySetting.editable_job_nums"
			:control-left="true"
			:params="{type:'boolean'}"
			v-on:change="numberChange($event,'project')">
		</field>
		<p class="text-muted" v-if="$store.company.CompanySetting.editable_job_nums == 0">Project #s will be determined by the system and readonly. Project numbering follows a ###-YY format (ex. 009-20 will be the 9th job of year 2020).</p>
		<p v-else class="text-muted">Project #s will still be determined by the system, but can be edited by users</p>

		<field label=" Allow Service #'s to be edited manually"
			col-class="col-auto"
			v-model="$store.company.CompanySetting.editable_service_nums"
			:control-left="true"
			:params="{type:'boolean'}"
			v-on:change="numberChange($event,'service')">
		</field>

		<p class="text-muted" v-if="$store.company.CompanySetting.editable_service_nums == 0">Service #s will be determined by the system and readonly. Service numbering follows a sequential 5-digit format.</p>
		<p v-else class="text-muted">Service #s will still be determined by the system, but can be edited by users</p>

	</widget>
</template>

<script>
import Widget from "@/components/Widget"
import Field from "@/components/Field"

export default {

	name: 'JobNumberingSettings',
	components: {
		Field,
		Widget
	},
	data() {
		return {

		}
	},

	methods: {
		numberChange(value,jobType) {
			let vm = this
			let payload = {}
			if (jobType == 'service') 
				payload.editable_service_nums = value ? 1 : 0
			else
				payload.editable_job_nums = value ? 1 : 0

			this.postData("CompanySetting/save",payload,true).then(response => {
				if (response.success)
					vm.alertSaved("Changes saved")
			})
		}
	}
}
</script>
